import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#000" }, [
      _createElementVNode("path", { d: "m10.244.152.707.707L.708 11.103 0 10.396z" }),
      _createElementVNode("path", { d: "m10.951 10.394-.707.707L0 .857.707.15z" })
    ], -1)
  ])))
}
export default { render: render }